import { useTranslation } from '@/features/shared/composables/useTranslation'
import { ACCOUNT_TYPE } from '@/features/shared/constants/accountType'
import { PERMISSIONS } from '@/features/shared/constants/permissions'

const t = useTranslation()

export const productsRoutes = [
  {
    path: 'brand-products',
    name: 'BrandProducts',
    component: () => import('@/features/brandProducts/views/BrandProducts.vue'),
    meta: {
      mainRouteName: 'BrandProducts',
      title: `${t('products')} | Pour Now`,
      permissionIdentifiers: [PERMISSIONS.CAN_VIEW_PRODUCT],
      visibleAccountTypes: [ACCOUNT_TYPE.BRAND],
    },
  },
  {
    path: 'brand-products/:productId/analytics',
    name: 'BrandProductAnalytics',
    component: () => import('@/features/brandProducts/views/BrandProductAnalytics.vue'),
    meta: {
      mainRouteName: 'BrandProducts',
      title: `${t('product_analytics')} | Pour Now`,
      // TODO:BACKEND Add permission
      visibleAccountTypes: [ACCOUNT_TYPE.BRAND],
    },
  },
  {
    path: 'brand-products/:productId',
    name: 'EditBrandProduct',
    component: () => import('@/features/brandProducts/views/EditBrandProduct.vue'),
    meta: {
      mainRouteName: 'BrandProducts',
      title: `${t('edit_product')} | Pour Now`,
      permissionIdentifiers: [PERMISSIONS.CAN_UPDATE_PRODUCT],
      visibleAccountTypes: [ACCOUNT_TYPE.BRAND],
    },
  },
]
